import {
  enumInventoryZoneSortOption,
  InventoryZoneSortOption,
  ZoneStatus,
  ZoneType,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { inventoryZonesQueryAtom } from '../_graphql/queryInventoryZones';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedFacility = atomFromQueryString.string('f');
export const $selectedZoneType = atomFromQueryString.string('type');
export const $selectedStatus = atomFromQueryString.string('status');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<InventoryZoneSortOption[]>([
  enumInventoryZoneSortOption.ZoneCodeAsc,
]);

export const $isCreateDialogOpen = atom(false);
export const $editingZoneId = atom<string | null>(null);

export const $remoteInventoryZones = inventoryZonesQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const selectedFacility = get($selectedFacility);
  const selectedZoneType = get($selectedZoneType);
  const selectedStatus = get($selectedStatus);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  const params: {
    searchTerm?: string;
    facilityId?: string;
    zoneType?: ZoneType[];
    status?: ZoneStatus[];
    limit: number;
    offset: number;
    sorting: InventoryZoneSortOption[];
  } = {
    limit,
    offset,
    sorting,
  };

  if (searchTerm) params.searchTerm = searchTerm;
  if (selectedFacility && selectedFacility !== 'all') {
    params.facilityId = selectedFacility;
  }
  if (selectedZoneType && selectedZoneType !== 'all') {
    params.zoneType = [selectedZoneType as ZoneType];
  }
  if (selectedStatus && selectedStatus !== 'all') {
    params.status = [selectedStatus as ZoneStatus];
  }

  return {
    variables: params,
  };
});
